import { createSelector, createSlice } from "@reduxjs/toolkit"
import type { RootState } from "~/store"
import { User } from "~/model/User"
import { WorkflowActor } from "~/model/Workflow"

/**

 */

type Authorization = {
  user: User | null,
  isRegisterTemplateForm: boolean
  guestToken: string | null,
}
const initialData = (): Authorization => ({
  user: null,
  isRegisterTemplateForm: true,
  guestToken: null,
})

export const authorizationSlice = createSlice({
  name: "authorization",
  initialState: initialData(),
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload
    },
    setIsRegisterTemplateForm: (state, action) => {
      state.isRegisterTemplateForm = action.payload
    },
    setGuestToken: (state, action) => {
      state.guestToken = action.payload
    },
    clear: (state) => {
      state.user = null
    },
  },
})
export const { setUser, clear, setIsRegisterTemplateForm, setGuestToken } = authorizationSlice.actions
export const selectAuthorization = (state: RootState) => state.authorization
export const selectActor = (state: RootState): WorkflowActor => {
  if (state.authorization?.user?.company?.type) {
    if (
      [WorkflowActor.MANAGEMENT, WorkflowActor.AGENT, WorkflowActor.OWNER_AGENCY].includes(
        WorkflowActor[state.authorization.user.company.type]
      )
    ) {
      return WorkflowActor[state.authorization.user.company.type]
    }
    return WorkflowActor.CONTRACTOR
  }
  return WorkflowActor.CONTRACTOR
}
export default authorizationSlice.reducer
